import momentTZ from "moment-timezone";
import { TDailyMenu } from "./type";

/**
 * The "ordering is closed" message shown on the Room page. This reads the
 * SERVER's canOrder/orderDeadlineAt (see server order-deadline.util.ts,
 * which is also what gates storeOrder/updateOrder) instead of recomputing
 * a client-side cutoff — the old `isCanOrder` util reproduced the weekday
 * table but had no holiday awareness, so it could disagree with the server
 * around a holiday like Labor Day and show an open form the server would
 * then reject.
 *
 * Returns "" (nothing to show) when the daily menu hasn't loaded yet, when
 * ordering is still open, OR when canOrder is absent (undefined/null) —
 * fail open, same as Table/index.tsx: a client deployed ahead of the
 * server, or a cached bundle against a rolled-back API, can hit a response
 * without these fields, and that must read as "ordering open", not as a
 * silent, unexplained lockout. Only an explicit `false` shows this message.
 */
export const getOrderDeadlineMessage = (daily: TDailyMenu | null): string => {
  if (!daily || daily.canOrder !== false || !daily.orderDeadlineAt) {
    return "";
  }

  const deadline = momentTZ.tz(daily.orderDeadlineAt, "America/Chicago");

  return `Sorry, you can't create or edit this order anymore — the deadline was ${deadline.format(
    "h:mm A",
  )} Central Time on ${deadline.format("dddd, MMMM D, YYYY")}.`;
};
